import { motion } from 'framer-motion';

export default function PharmacyCTABar() {
  return (
    <section
      aria-labelledby="cta-bar-heading"
      className="bg-gray-900 py-10 px-6"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <h2 id="cta-bar-heading" className="text-2xl md:text-3xl font-bold text-white">
            Get a free pharmacist consultation
          </h2>
          <p className="text-gray-400 text-sm mt-1">
            Walk in, call, or request a callback — no appointment required.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="flex flex-col sm:flex-row gap-3 flex-shrink-0"
        >
          <a
            href="tel:9057099985"
            className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-100 text-gray-900 font-semibold px-7 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-phone-fill text-teal-600" aria-hidden="true"></i>
            (905) 709-9985
          </a>
          <a
            href="/location"
            className="inline-flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-semibold px-7 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-map-pin-line" aria-hidden="true"></i>
            Visit Us Today
          </a>
        </motion.div>
      </div>
    </section>
  );
}
